import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import UIButton from "@verivest/shared-components/src/buttons/Button";
import React from "react";
import SplitDistribution from "../../pages/investor-portal/wizards/investment/DistributionPreferences/SplitDistribution";
import TypeSelector from "../../pages/investor-portal/wizards/investment/DistributionPreferences/TypeSelector";
import WizardInvestmentDistributionPreferencesReceive from "../../pages/investor-portal/wizards/investment/DistributionPreferencesReceive";

const DistributionPreferencesDrawer = ({
  investment,
  distributionPreference,
  onFinish,
  onClose,
  showAddressDisclaimer,
  titleSelectorProps,
  wizardInvestmentDistributionPreferencesReceiveBankProps,
  wizardInvestmentDistributionPreferencesReceiveSelectionProps,
}) => {
  const [isTypeSelector, setIsTypeSelector] = React.useState(true);
  const [selectedType, setSelectedType] = React.useState("");
  const [isAlreadyOpen, setIsAlreadyOpen] = React.useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = React.useState(false);

  const goBackToTypeSelector = () => {
    setIsTypeSelector(true);
  };

  const askForUnsavedChanges = () => {
    if (isTypeSelector) {
      onClose();
    } else {
      setIsConfirmModalOpen(true);
    }
  };

  let view = null;

  if (isTypeSelector) {
    view = (
      <TypeSelector
        distributionPreference={distributionPreference}
        investment={investment}
        onContinue={(done, type) => {
          done ? onFinish() : setIsTypeSelector(false);
          setSelectedType(type);
          setIsAlreadyOpen(true);
        }}
        onClose={askForUnsavedChanges}
        noAnimation={isAlreadyOpen}
        asDrawer
        {...titleSelectorProps}
      />
    );
  } else if (
    selectedType === "split" ||
    selectedType === "split distribution"
  ) {
    view = (
      <SplitDistribution
        investment={investment}
        distributionPreference={distributionPreference}
        asDrawer
        onFinish={onFinish}
        onBackToTypeSelection={() => goBackToTypeSelector()}
        initialData={distributionPreference}
        onClose={askForUnsavedChanges}
        wizardInvestmentDistributionPreferencesReceiveBankProps={
          wizardInvestmentDistributionPreferencesReceiveBankProps
        }
        wizardInvestmentDistributionPreferencesReceiveSelectionProps={
          wizardInvestmentDistributionPreferencesReceiveSelectionProps
        }
      />
    );
  } else if (
    selectedType === "receive" ||
    selectedType === "check" ||
    selectedType === "bank transfer"
  ) {
    view = (
      <WizardInvestmentDistributionPreferencesReceive
        onBackToTypeSelection={() => goBackToTypeSelector()}
        initialData={distributionPreference}
        distributionPreference={distributionPreference}
        investment={investment}
        onFinish={onFinish}
        onClose={askForUnsavedChanges}
        showAddressDisclaimer={showAddressDisclaimer}
        noRedirect
        asDrawer
        wizardInvestmentDistributionPreferencesReceiveBankProps={
          wizardInvestmentDistributionPreferencesReceiveBankProps
        }
        wizardInvestmentDistributionPreferencesReceiveSelectionProps={
          wizardInvestmentDistributionPreferencesReceiveSelectionProps
        }
      />
    );
  }

  return (
    <>
      {view}
      {isConfirmModalOpen && (
        <Modal isOpen={true} onClose={() => null} closeOnOverlayClick={false}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Unsaved changes</ModalHeader>
            <ModalBody>
              {"If you don't save you will lose your changes."}
            </ModalBody>
            <ModalFooter>
              <UIButton label={"Don't save"} onClick={onClose} isLarge isBold />
              <UIButton
                ml={3}
                label={"Cancel"}
                onClick={() => setIsConfirmModalOpen(false)}
                isLarge
                isBold
                outline
              />
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};

export default DistributionPreferencesDrawer;
